import { useEffect, useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import useUserStore from "../../../utils/storeApp";
import { Column } from "primereact/column";
import CallAPI from "../../../services/apiCalls";
import { Tag } from "primereact/tag";
import $ from "jquery";
import { useReactToPrint } from "react-to-print";

const ListDownloadStatus = () => {
  const { userRole, userToken, SetSharedObject } = useUserStore((state) => ({
    userRole: state.userRole,
    userToken: state.userToken,
    SetSharedObject: state.SetSharedObject,
  }));
  const [processing, SetProcessing] = useState(false);
  const [reportObj, setReportObj] = useState([]);
  const [cmfFlag, SetCmfFlag] = useState(false);
  const [errMsg, SetErrMsg] = useState(false);
  const [processingDelete, setprocessingDelete] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState([]);

  const [sortField, setSortField] = useState('requestDate');
  const [sortOrder, setSortOrder] = useState(-1); // 1 for ascending, -1 for descending
  const [first, setFirst] = useState(0); // Initial first record index
  const [rows, setRows] = useState(25); // Number of rows per page
  const [totalRecords, setTotalRecords] = useState(0);


  const userActions = (row, type) => {
    SetCmfFlag(false);
    if (type === "Download") {
      openAttachment(row.s3DownLoadUrl);
    } else if (type === "Delete") {
      setSelectedProduct([row]);
      //row.reportId
      DeleteEmailComfirm();
    }
  };

  const DeleteEmailComfirm = () => {
    if (selectedProduct.length === 0) {
      SetCmfFlag(true);
    }
    $("#comfirmDelete").modal("show");
  };

  const multiDelete = async () => {
    for (let row of selectedProduct) {
      await deleteReports(row.reportId, true);
    }
    $("#comfirmDelete").modal("hide");
    getReports();
  };

  const openAttachment = async (url) => {
    window.open(url);
    return;
  };

  const deleteReports = async (id, flag) => {
    setReportObj([]);
    setprocessingDelete(true);
    let call = "/reports/DeleteReportRequest?reportId=" + id;
    const res = await CallAPI(call, false, "get", userToken);
    SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      setprocessingDelete(false);
      if (!flag) getReports();
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      if (Object.keys(msg).length > 0 && msg.constructor === Object) {
        let str = "<div>";
        for (let el in msg) {
          str += `${el}`;
        }
        str += "</div>";
        SetErrMsg(str);
      } else {
        SetErrMsg(msg);
      }
    }
  };

  useEffect(() => {
    getReports();
  }, [sortField, sortOrder, first, rows]);

  const getReports = async () => {
    SetErrMsg(false);
    setSelectedProduct([]);
    setReportObj([]);
    SetProcessing(true);

    const sortDir = sortOrder === 1 ? 'ASC' : 'DESC';
    const page = Math.ceil((first + 1) / rows);

    let currentSortField = sortField;
    if (currentSortField === 'RType') {
      currentSortField = 'ReportType';
    } else if (currentSortField == 'DownloadStatus') {
      currentSortField = 'ReportStatus';
    } else if (currentSortField == 'fullNameDisplay') {
      currentSortField = 'UserName';
    }

    let call = "/reports/GetReportsStatus?page=" + page + "&pageSize=" + rows + "&sortBy=" + currentSortField + "&sortDir=" + sortDir;
    const res = await CallAPI(call, false, "get", userToken);

    SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {

      setTotalRecords(res.data.data.count);
      ReportsGrid(res.data.data.pageItems);

      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
  };

  const ReportsGrid = (obj) => {
    let tempObj = [];
    let opt = ["Download", "Delete"];
    for (const row of obj) {
      let show = row.reportStatus !== "Ready" ? 0 : 1;
      row.RType = row.reportTypeName.replaceAll("1", " ");
      let select = (
        <span>
          {/* row.reportStatus === "Ready" ? */}
          <button
            onClick={(e) => {
              if (row.reportStatus === "Ready") userActions(row, "Download");
            }}
            className={`btn btn-outline-secondary btn-sm ${row.reportStatus !== "Ready" ? "disabled" : ""
              }`}
            style={{ minWidth: "25px", border: "none", opacity: show }}
          >
            <i className="bi bi-download"></i>
          </button>
          {/* :null} */}
          <button
            onClick={(e) => userActions(row, "Delete")}
            className="btn btn-outline-danger btn-sm ml-1"
            style={{ minWidth: "25px", border: "none" }}
          >
            <i className="bi bi-trash"></i>
          </button>
        </span>
      );
      row.Actions = select;
      if (row.reportStatus === "Failed") {
        let status = (
          <Tag
            severity={"danger"}
            onClick={(el) => {
              $("#FailedReportModal").modal("show");
            }}
          >
            Failed <i class="bi bi-exclamation-triangle-fill"></i>
          </Tag>
        );
        row.DownloadStatus = status;
      } else if (row.reportStatus === "Ready") {
        let s = <Tag severity={"success"}>Ready</Tag>;
        row.DownloadStatus = s;
      } else {
        let d = <Tag severity={"warning"}>In Progress</Tag>;
        row.DownloadStatus = d;
      }
      let dName = JSON.parse(row?.reportParameters)?.DomainName;
      row.DomainName = dName;
      tempObj.push(row);
    }
    setReportObj(tempObj);
  };

  const getSeverity = (product) => {
    switch (product.DownloadStatus) {
      case "Ready":
        return "success";
        break;
      case "In Progress":
        return "warning";
        break;
      case "Failed":
        return "danger";
        break;
      default:
        return null;
        break;
    }
  };

  const formatSentDate = (dt) => {
    return dt.requestDate ? new Date(dt.requestDate).toLocaleString() : null;
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const refreshPage = () => {
    getReports();
  };

  const handleColumnSort = (event) => {
    setSortField(event.sortField);
    setSortOrder(event.sortOrder);
  };

  const handlePageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  return (
    <div className="ListDownloadStatus" ref={componentRef}>
      <div className="HeaderDownloadStatusTool">
        <header>
          <div className="title-label">
            <i
              className="bi bi-box-arrow-in-down"
              aria-labelledby="Download status"
              alt="Download Status icon"
            ></i>
            <span className="spacer-margin2">Download Status</span>
          </div>
          <div className="mid-header-bar spacer-inline">
            <span className="SharedTools">
              <button
                className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                title="Refresh Page"
                onClick={(e) => {
                  if (totalRecords > 0) refreshPage();
                }}
              >
                <i
                  className="bi bi-arrow-clockwise"
                  alt="refresh page icon"
                ></i>
              </button>
              <button
                className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                title="Print page"
                onClick={(e) => {
                  if (totalRecords > 0) handlePrint();
                }}
              >
                <i className="bi bi-printer" alt="printer icon"></i>
              </button>
            </span>
          </div>
        </header>
      </div>
      <section className="grid-layout">
        <div>
          <DataTable
            value={reportObj}
            paginator
            selectionPageOnly
            lazy
            rowsPerPageOptions={[25, 50, 75]}
            tableStyle={{ minWidth: "50rem" }}
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            dataKey="reportId"
            selectionMode={"checkbox"}
            selection={selectedProduct}
            onSelectionChange={(e) => setSelectedProduct(e.value)}
            columnResizeMode="expand"
            resizableColumns
            scrollable
            first={first}
            rows={rows}
            totalRecords={totalRecords}
            sortField={sortField}
            sortOrder={sortOrder}
            onSort={handleColumnSort}
            onPage={handlePageChange}
          >
            <Column selectionMode="multiple" className="w-s"></Column>
            <Column
              field="fileName"
              header="File Name"
              className="truncate"
              sortable
            ></Column>
            <Column
              field="requestDate"
              header="Request Date"
              className="w-md8"
              sortable
              body={formatSentDate}
            ></Column>
            <Column
              field="fullNameDisplay"
              header="Started By"
              className="truncate"
              sortable
            ></Column>
            <Column
              field="RType"
              header="Report Type"
              className="w-md7"
              sortable
            ></Column>
            <Column
              field="domainName"
              header="Domain"
              className="truncate"
              sortable
            ></Column>
            <Column
              field="DownloadStatus"
              header="Status"
              className="w-md1"
              sortable
            ></Column>
            <Column
              field="Actions"
              header="Actions"
              className="w-md1"
            ></Column>
          </DataTable>
          <div className="paging">
            <div className="spacer-inline spacer-margin9">
              <button
                className="btn btn-outline-secondary"
                onClick={(e) => DeleteEmailComfirm()}
              >
                {" "}
                Delete{" "}
              </button>
            </div>
          </div>
        </div>
      </section>
      {/* <FailedReportView /> */}
      <div
        className="modal fade"
        id="comfirmDelete"
        data-backdrop="static"
        data-keyboard="false"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="delete Modal Comfirm"
        aria-hidden="false"
      >
        <div className="modal-dialog ">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title">Delete Confirmation</div>
              <button
                type="button"
                className="close"
                aria-label="Close"
                data-dismiss="modal"
              >
                <span aria-hidden="false">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {selectedProduct.length === 0 ? (
                <div class="ctr sp-pad3">
                  There was nothing selected to delete.
                </div>
              ) : (
                <>
                  <div className="field-wrapper">
                    <div className="spacer-margin7 line-s1">
                      <label>
                        Are you sure you want to delete the reports listed
                        below?
                      </label>
                    </div>
                    <ul className="sp-margin4">
                      {selectedProduct.map((el) => (
                        <li key={el.reportId}>{el.fileName}</li>
                      ))}
                    </ul>
                  </div>

                  {errMsg ? (
                    <div className="alert alert-danger">{errMsg}</div>
                  ) : null}
                </>
              )}
            </div>
            <div className="modal-footer">
              {selectedProduct.length === 0 ? null : (
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={(e) => multiDelete()}
                >
                  Confirm
                </button>
              )}
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-dismiss="modal"
              >
                {selectedProduct.length === 0 ? "Close" : "Cancel"}
              </button>
              {processingDelete ? <div className="loading"></div> : null}
            </div>
          </div>
        </div>
      </div>
      {processing ? <div className="loading"></div> : null}
    </div>
  );
};

export default ListDownloadStatus;
